'use client';

import React, { ReactNode } from 'react';
import LocalImage from './LocalImage';
import Video from './Video';
import Collage from './Collage';

const Banner = React.forwardRef<
  HTMLDivElement,
  {
    image?: string | null;
    video?: string | null;
    background?: string | null;
    bannerType: string;
    contentClassName?: string;
    className?: string;
    children: ReactNode;
    unoptimize?: boolean;
    altText?: string;
    dataTestId?: string;
  }
>(
  (
    { image, video, background, bannerType, contentClassName = '', className = '', children, unoptimize = true, altText = '', dataTestId = 'banner' },
    ref,
  ) => {
    const getBanner = (type: typeof bannerType) => {
      if (type === 'Image')
        return (
          <LocalImage url={image} className={contentClassName} unoptimize={unoptimize} alt={altText} data-testid={`${dataTestId}-local-image`} />
        );
      else if (type === 'Video') return <Video url={video} className={contentClassName} data-testid={`${dataTestId}-video`} />;
      else if (type === 'Collage')
        return (
          <Collage
            background={background}
            content={{ children, image, video }}
            className={contentClassName}
            unoptimize={unoptimize}
            altText={altText}
            data-testid={`${dataTestId}-collage`}
          />
        );
    };

    return (
      <>
        <div ref={ref} className={`${className} banner-container relative`} data-testid={dataTestId}>
          {getBanner(bannerType)} {bannerType === 'Collage' ? <></> : <div data-testid={`${dataTestId}-children`}>{children}</div>}
        </div>
        <style jsx>{`
          .banner-container :global(.brand-logo) {
            transform: scale(0.7) translate(20%, -20%);
          }
          @media (min-width: 768px) {
            .banner-container :global(.brand-logo) {
              transform: scale(0.85) translate(8%, -8%);
            }
          }
          @media (min-width: 1024px) {
            .banner-container :global(.brand-logo) {
              transform: scale(1);
            }
          }
        `}</style>
      </>
    );
  },
);

export default Banner;
